export default __webpack_public_path__ + "static/color-application-light-09cafa2718180192b34ab43c8c832038.png";